export const storeImageBase64 =(data)=>{
    console.warn("action",data)
    return {
        type:"STORE_IMAGE",
        data:data
    }
}
